import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IInstagramStory } from "../instagramStoryModel";

export const getAllInstagramStories = createAsyncThunk(
  "InstagramStory/FindAllInstaGram",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/InstagramStory/FindAllInstaGram`,
        {
          Title: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Instagram Stories:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createInstagramStory = createAsyncThunk(
  "InstagramStory/InsertInstaGram",
  async (InstagramStoryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/InstagramStory/InsertInstaGram`,
        InstagramStoryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating instagram story:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateInstagramStory = createAsyncThunk(
  "InstagramStory/UpdateInstaGram",
  async (InstagramStoryData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/InstagramStory/UpdateInstaGram`,
        InstagramStoryData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating instagram story:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteInstagramStory = createAsyncThunk(
  "InstagramStory/DeleteInstaGram",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/InstagramStory/DeleteInstaGram`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting instagram story:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getInstagramStoryByID = createAsyncThunk(
  "InstagramStory/FindByIDInstaGram",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/InstagramStory/FindByIDInstaGram`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        URL: result.URL,
        ThumbnailImage: result.ThumbnailImage,
        VideoUpload: result.VideoUpload,
        IsActive: result?.IsActive ? 1 : 2,
      } as IInstagramStory;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching instagram story:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveInstagramStories = createAsyncThunk(
  "InstagramStory/FindAllActiveInstaGram",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/InstagramStory/FindAllActiveInstaGram`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Instagram Stories:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveInstagramStory = createAsyncThunk(
  "InstagramStory/ActiveInActiveInstaGram",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/InstagramStory/ActiveInActiveInstaGram`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive instagram story:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const InstagramStoryImageUpload = createAsyncThunk(
  "InstagramStory/UpdateInstaGramImage",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/InstagramStory/UpdateInstaGramImage`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Instagram Story Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
